const data = {
 name: 'דוד אמסלם',
 role: 'יועץ ומשווק נדלן',
 logo: './assets/logoImg.png',
 header: './assets/001-img.jpeg',
 poster: './assets/poster.jpg',
 addContact: './assets/דוד חי אמסלם יועץ ומשווק נדלן.vcf',
 linkWaze: 'https://waze.com/ul/hsvbfsmq4s',
 linkMail: 'mailto:as149@walla.com',
 linkWhatsapp: 'https://api.whatsapp.com/send?phone=9720525520876',
 linkPhone: 'tel:0525520876',
 linkNehasim: 'https://wa.me/c/972525520876',
 linkFacebook: 'https://www.facebook.com/davidhaiamsalem',
 shareLinkMail:
  'mailto:?subject=%D7%9B%D7%A8%D7%98%D7%99%D7%A1%20%D7%91%D7%99%D7%A7%D7%95%D7%A8%20%D7%93%D7%99%D7%92%D7%99%D7%98%D7%9C%D7%99%20%D7%A9%D7%9C%20%D7%93%D7%95%D7%93%20%D7%90%D7%9E%D7%A1%D7%9C%D7%9D%20-%20%D7%99%D7%95%D7%A2%D7%A5%20%D7%95%D7%9E%D7%A9%D7%95%D7%95%D7%A7%20%D7%A0%D7%93%D7%9C%22%D7%9F&amp;body=https%3A%2F%2Famsalem-david.web.app',
 shareLinkSms:
  'sms://?&amp;body=%D7%9B%D7%A8%D7%98%D7%99%D7%A1%20%D7%91%D7%99%D7%A7%D7%95%D7%A8%20%D7%93%D7%99%D7%92%D7%99%D7%98%D7%9C%D7%99%20%D7%A9%D7%9C%20%D7%93%D7%95%D7%93%20%D7%90%D7%9E%D7%A1%D7%9C%D7%9D%20-%20%D7%99%D7%95%D7%A2%D7%A5%20%D7%95%D7%9E%D7%A9%D7%95%D7%95%D7%A7%20%D7%A0%D7%93%D7%9C%22%D7%9F%20https%3A%2F%2Famsalem-david.web.app',
 shareLinkWhatsapp:
  'https://api.whatsapp.com/send?text=*%D7%9B%D7%A8%D7%98%D7%99%D7%A1%20%D7%91%D7%99%D7%A7%D7%95%D7%A8%20%D7%93%D7%99%D7%92%D7%99%D7%98%D7%9C%D7%99%20%D7%A9%D7%9C%20%D7%93%D7%95%D7%93%20%D7%90%D7%9E%D7%A1%D7%9C%D7%9D%20-%20%D7%99%D7%95%D7%A2%D7%A5%20%D7%95%D7%9E%D7%A9%D7%95%D7%95%D7%A7%20%D7%A0%D7%93%D7%9C%22%D7%9F*%20https%3A%2F%2Famsalem-david.web.app',
 shareLinkFacebook:
  'https://www.facebook.com/sharer.php?u=https%3A%2F%2Famsalem-david.web.app',
 galleryImages: [
  './assets/001-img.jpeg',
  './assets/002-img.jpeg',
  './assets/003-img.jpeg',
  './assets/004-img.jpeg',
  './assets/005-img.jpeg',
 ],
 videos: ['./assets/video_1.mp4', './assets/video_2.mp4'],
};

export default data;
